<template>
  <div class="appHead" :class="{ dark: isLives }">
    <div class="head1">
      <span v-if="backVisible">
        <a href="javascript:;" class="icon icon-back" @click="goBack"></a>
      </span>
      <div class="ifuyin" v-if="isLives">
        <img src="static/logo-icon.png" />一起看-福音影视网 iFUYIN.COM
      </div>
      <div v-else>{{ title }}</div>
    </div>
    <div class="head2" v-if="isLives">
      <a href="/short/index.html?#/short">微视频</a>
      <i></i>
      <b class="live">一起看<label>直播</label></b>
    </div>
  </div>
</template>
<script>
import app from '../../app'

export default {
  props: {
    backVisible: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    title() {
      return this.$service.common.title || this.$route.meta.title || '福音TV'
    },
    isLives() {
      return this.$route.path.indexOf('/lives') >= 0
    }
  },
  methods: {
    goBack() {
      if (window.inApp) {
        let route = this.$route.name
        this.$router.go(-1)
        setTimeout(() => {
          if (this.$route.name == route) {
            app.callGoBack()
          }
        }, 20);
      } else {
        this.$router.go(-1)
      }
    },
    showMenu() {
      this.$service.common.menu = true
    }
  }
}
</script>
<style scoped lang='scss'>
.appHead {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  line-height: $app-head-height - $app-status-height;
  padding-top: $app-status-height;
  color: $color-white;
  background-color: $color-red;

  &.dark {
    background-color: black;
    color: white;
  }
}

.head1 {
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: $app-head-height;

  >div {
    flex: 1;
    text-align: center;
    font-size: 20px;
  }

  >span {
    width: 44px;

    a {
      display: inline-block;
      width: 44px;
      text-align: center;
      font-size: 20px;
    }

    &:last-child {
      text-align: right;
    }
  }
}

.head2 {
  display: flex;
  align-items: center;
  justify-content: center;
  height: $app-head-height;
  font-size: 18px;

  i {
    display: inline-block;
    width: 1px;
    height: 15px;
    margin: 0 10px;
    background-color: white;
  }

  .live {
    position: relative;

    label {
      position: absolute;
      left: 100%;
      bottom: 12px;
      font-size: 10px;
      background-color: #F05F5F;
      color: white;
      white-space: nowrap;
      border-radius: 4px;
      line-height: 1;
      padding: 1px 2px;
    }
  }
}

.ifuyin {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px !important;
  font-weight: bold;

  img {
    width: 24px;
    height: 24px;
    margin-right: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// AppHead.vue?627506c4